import React from "react";
import aeroNerd from "assets/aeroNerd.png";
import infoNerd from "assets/infoNerd.png";
import legalNerd from "assets/legalNerd.png";
import marketingNerd from "assets/marketingNerd.png";
import riskNerd from "assets/riskNerd.png";
import techNerd from "assets/techNerd.png";
import Avatars from "components/Avatars";

const HomeWhoWeAre = () => (
	<div
		id="home-who-we-are"
		className="py-16 md:py-28 text-center bg-darkblue flex justify-center text-center text-white dark:text-white flex-col"
	>
		<div className="max-w-xxl my-16 flex gap-8 flex-col px-8 md:px-36 ">
			<h2 className="text-white">Who are we?</h2>
			<h3 className="uppercase text-white">
				A CHIEF TECHNOLOGY OFFICER, A CHIEF INFORMATION OFFICER, A VP OF RISK,
				AN AIRCRAFT ENGINEER, A MARKETING CONSULTANT & OUR TOKEN LAWYER.
			</h3>
			<p className="text-white">
				Yes, an unlikely bunch. But, we discovered over a pint that none of us
				(except for the lawyer) had a will, trust or real plan… and thought we
				probably should. With that, we set off to create a dead easy path for
				others to avoid our mistakes.
			</p>
		</div>
		<div className="grid items-start gap-6 mb-8 max-md:grid-cols-2 grid-cols-6 px-8">
			<Avatars image={techNerd} title="Tech Nerd" />
			<Avatars image={infoNerd} title="Info Nerd" />
			<Avatars image={riskNerd} title="Risk Nerd" />
			<Avatars image={aeroNerd} title="Aero Nerd" />
			<Avatars image={marketingNerd} title="Marketing Nerd" />
			<Avatars image={legalNerd} title="Legal Nerd" />
		</div>
	</div>
);

export default HomeWhoWeAre;
